import {Config} from "@/types/config";



export default function ():Config{
    return {
        baseURL: 'https://teljob.jingyujituan.com/',
    };
}
